import { Modal, Box } from "@mui/material";
import { useRestaurant } from "../hooks/RestaurantContext";
import { useDispatch, useSelector } from "react-redux";
import { getCarouselPreview, getCarouselsError, getCarouselsStatus, selectCarouselPreview } from "../features/carouselSlice";
import { useEffect } from "react";
import Loading from "./loading";
import Error from "./Error";
import { useTranslation } from "react-i18next";

const PreviewModal = ({ open, handleClose }) => {
    const { t } = useTranslation();
    const { restaurantId } = useRestaurant();
    const dispatch = useDispatch();
    const status = useSelector(getCarouselsStatus);
    const error = useSelector(getCarouselsError);
    const previewData = useSelector(selectCarouselPreview);

    useEffect(() => {
        if (open) {
            dispatch(getCarouselPreview(restaurantId));
        }
    }, [dispatch, restaurantId, open]);

    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="preview-modal">
            <Box
                sx={{
                    width: '35vw',
                    height: '85vh',
                    backgroundColor: 'white',
                    margin: 'auto',
                    marginTop: '10vh',
                    boxShadow: 24,
                    p: 1,
                    borderRadius: 2,
                }}
            >
                {status === "loadingPreview" ? (
                    <Loading size={16} />
                ) : status === "fetchPreviewError" ? (
                    <Error>{error}</Error>
                ) : (
                    <iframe
                        srcDoc={previewData}
                        title={t("mediaPicker.preview")}
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                    />
                )}
            </Box>
        </Modal>
    );
};
export default PreviewModal;